import Swing from './types/Swing.ts'

export default function updateUrl(playerList: Swing[], selectedIdx: number) {
    const url = new URL(window.location.href)
    url.searchParams.set('playerList', playerList.map((p) => p.id).join(','))
    url.searchParams.set('selectedIdx', String(selectedIdx))

    window.history.replaceState('', '', url)
}
